import { render, staticRenderFns } from "./CompTableGeneral.vue?vue&type=template&id=9aa95a48&scoped=true"
import script from "./CompTableGeneral.vue?vue&type=script&lang=js"
export * from "./CompTableGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa95a48",
  null
  
)

export default component.exports